import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

const GSTDeclarationDocumentPDF = ({ formData }) => {
  const nameValue = formData?.gst_declaration_name !== undefined && formData?.gst_declaration_name !== '' ? formData?.gst_declaration_name : (formData?.personName || formData?.companyName || '');
  const isTAFundingByMT = formData?.is_ta_funding_by_mt;
  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      fontSize: 11,
      paddingTop: 60,
      paddingBottom: 60,
      paddingLeft: 70,
      paddingRight: 70,
      fontFamily: "Times-Roman",
      lineHeight: 1.5,
    },
    toSection: {
      marginBottom: 20,
    },
    companyName: {
      fontSize: 11,
      fontWeight: "bold",
      fontFamily: "Times-Bold",
      marginBottom: 5,
    },
    address: {
      fontSize: 11,
      marginBottom: 2,
    },
    subject: {
      fontSize: 11,
      fontWeight: "bold",
      fontFamily: "Times-Bold",
      marginBottom: 20,
      marginTop: 20,
    },
    greeting: {
      fontSize: 11,
      marginBottom: 20,
    },
    paragraph: {
      fontSize: 11,
      lineHeight: 1.5,
      textAlign: "justify",
      marginBottom: 20,
    },
    bold: {
      fontWeight: "bold",
      fontFamily: "Times-Bold",
    },
    closing: {
      fontSize: 11,
      marginBottom: 40,
      marginTop: 20,
    },
    signatureSpace: {
      marginBottom: 20,
      borderBottom: "1px solid black",
      width: 150,
      height: 1,
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* To Section */}
        <View style={styles.toSection}>
          <Text>To,</Text>
          {isTAFundingByMT ? (
            <>
              <Text style={styles.companyName}>Krishak Sevita Online Solutions Private Limited (KSOS)</Text>
              <Text style={styles.address}>Global Square,Sr No. 247+14B,</Text>
              <Text style={styles.address}>6th Floor, Off No.607&608,</Text>
              <Text style={styles.address}>Deccan College Road, Yerwada, Pune-411006,</Text>
              <Text style={styles.address}>Maharashtra, India</Text>
            </>
          ) : (
          <>
            <Text style={styles.companyName}>
              Tyger Capital Private Limited (Formerly Known as Adani Capital Private Limited)
            </Text>
            <Text style={styles.address}>1004/5, Level 10</Text>
            <Text style={styles.address}>C Wing, One BKC</Text>
            <Text style={styles.address}>Bandra Kurla Complex, Bandra (East)</Text>
            <Text style={styles.address}>Mumbai - 400051</Text>
          </>
          )}
        </View>

        {/* Subject */}
        <Text style={styles.subject}>
          Subject: Declaration Regarding Unavailability of GST Certificate
        </Text>

        {/* Greeting */}
        <Text style={styles.greeting}>Dear Sir/Madam,</Text>

        {/* First Paragraph */}
        <Text style={styles.paragraph}>
          This is to declare that <Text style={styles.bold}>{nameValue}</Text> is currently not in possession of a GST certificate as it is not registered under the Goods and Services Tax (GST) Act.
        </Text>

        {/* Second Paragraph */}
        <Text style={styles.paragraph}>
          We hereby confirm that, we do not meet the eligibility criteria for GST registration as per the applicable laws and regulations. In the event that our company becomes liable for GST registration in the future, we shall promptly inform you and provide the necessary documents, including the GST certificate.
        </Text>

        {/* Closing */}
        <Text style={[styles.closing, styles.bold]}>Sincerely,</Text>

        {/* Signature Space */}
        <View style={styles.signatureSpace}></View>
      </Page>
    </Document>
  );
};

export default GSTDeclarationDocumentPDF;